import siteInfo from "@/constants/siteInfo";

const TRAILING_SEPARATORS = /[\s\-–—|:]+$/;
// Brand already present at the end, in any legacy spelling ( ).
const TRAILING_BRAND = /[\s\-–—|:]*\bNews\s?Tak\s*$/i;

// Removes trailing separators/whitespace, e.g. the CMS sends meta titles ending in " - ".
export const trimTitle = (title = "") =>
  `${title ?? ""}`.replace(TRAILING_SEPARATORS, "").trim();

// "<title> - UPTak", with exactly one brand suffix in the standard spelling.
export const withBrandSuffix = (title = "") => {
  const base = trimTitle(trimTitle(title).replace(TRAILING_BRAND, ""));
  return base ? `${base} - ${siteInfo.siteName}` : siteInfo.siteName;
};
  